module.exports = "query createSalesExport($sort:Sort,$filters:[Filter!],$view:String){createSalesExport(sort:$sort,filters:$filters,view:$view)}"